"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapS = void 0;
var id_fn_1 = require("../functions/id-fn");
var map_each_1 = require("./map-each");
var mapS = function (mapFn) { return (0, map_each_1.mapEach)(id_fn_1.idfn, id_fn_1.idfn, mapFn); };
exports.mapS = mapS;
